export enum EnderecoTipo {
    RESIDENCIAL = 1,
    COMERCIAL = 2,
    OUTRO = 7
}
